export default __webpack_public_path__ + "static/media/oil.0df6a743.svg";